import { IExercisesTableData } from '../../pages/AdminPanel/Exercises/PatientExercisesTable/patientExercisesTable.interface';
import { IMeta } from './response';
import { IUser } from './user';

export interface IExercisesTableDataResponse {
 _id: string;
 patientId: string;
 stageId: number | string;
 autoRefresh: boolean;
 isHistory?: boolean;
 hasHistory?: boolean;
 patient: IUser;
 exercises: IExercisesTableData[];
}

export interface IUpdateExercisesTableDto extends Omit<
 IExercisesTableDataResponse,
 'patient'
> {}

export interface IDailyExerciseTableData {
 patient: IUser;
 _id: string;
 isCompleted: boolean;
 startTime: string;
 endTime: string;
 exercise: IExercisesTableData;
}

export interface IDailyExerciseTableDataResponse {
 exercises: IDailyExerciseTableData[];
}

export interface ICreateSubscriptionByPatientResponse {
 _id: string;
 startTime: string;
 endTime: string;
 serviceId: string;
 patientId: string;
 amountOfVisits: number;
 amountOfUsedVisits: number;
 lastTimeUsed: string;
 price: number;
 status: string;
 currency: string;
}
export interface IUpdateDailyExerciseTableDataRequest extends Omit<
 IExercisesTableDataResponse,
 'patientId' | 'patient'
> {}

export interface IDailyExerciseQuery {
 isCompleted?: boolean;
 placeId?: string;
 doctorId?: string;
 from?: string;
 to?: string;
}

export interface IExerciseTableHistoryQuery {
 id: string;
 limit?: number;
 page?: number;
 sortField: string;
 sortOrder: number;
}

export interface IExerciseTableHistoryResponse {
 meta: IMeta;
 items: IExercisesTableDataResponse[];
}

export enum StageActionEnum {
 none = 'none',
 reset = 'reset',
}
